// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"PromoModal_modalContent__TEJ2q"};